<template>
    <div v-if="visibilityState !== 'hidden'" class="alzata-splash" :class="{ hiding: visibilityState !== 'visible' }">
        <alzata-splash-image />
    </div>
    <slot v-if="visibilityState !== 'visible'" />
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'AlzataSplash',
    watch: {
        visibilityState(newVal) {
            if (newVal === 'hiding') {
                setTimeout(() => {
                    this.hideSplash();
                }, 1000);
            }
        },
    },
    computed: mapState({
        initialLoadComplete: state => state.splash.initialLoadComplete,
        visibilityState: state => state.splash.visibilityState,
        splashState: state => state.splash,
    }),
    methods: mapActions('splash', ['hideSplash']),
};
</script>